<div [class.show]="isLoading" class="loading-overlay">
  <mat-progress-spinner diameter="64" mode="indeterminate"></mat-progress-spinner>
</div>
